export { Trash3 as default } from './Trash3';
